import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.breakpoint('md')} {
    width: 500px;
    height: fit-content;
  }
  background-color: #fff;
  border-radius: 6px;
  width: 100%;
  ${({ theme }) => theme.breakpoint('md')} {
    margin-top: 43px;
  }
  > * {
    &:first-child {
      margin-bottom: 8px;
    }
  }
`;
